/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";



am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const AverageChart = (props) => {

    const { sBA, data } = props

    useEffect(() => {
        if (data) {
            if (data.lstGraphBar.length > 0) {
                (data.lstGraphBar || []).forEach(element => {
                    onRenderGraphStackBar(element.lstData, element.sId, element.nMaxScore, element.sQuestionair);
                });
            }
            onRenderGraphPie(data.lstGraphPie);
        }


    }, [data])

    const onRenderGraphStackBar = (data, index, nMaxScore, sTitle) => {
        let chart = am4core.create(`bar_${index}`, am4charts.XYChart);

        let title = chart.titles.create();
        title.text = sTitle;
        title.fontSize = 16;
        title.marginBottom = 0;
        title.align = "left";
        title.fontWeight = '400';

        chart.data = data;

        // Create axes
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.opacity = 0;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.max = nMaxScore;
        valueAxis.strictMinMax = true;
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;

        // Create series
        function createSeries(field) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueX = field;
            series.dataFields.categoryY = "name";
            series.columns.template.tooltipText = "{categoryY}: {valueX}";
        }
        createSeries("value");

        let idx = parseInt(index) ?? 0;

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: idx,
                    nOrder: idx + 1,
                    sDesc: "Div 1 bar",
                    sName: "",
                    idDiv: 1,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }

    const onRenderGraphPie = (data) => {
        let chart = am4core.create("pie_avg", am4charts.PieChart);

        let title = chart.titles.create();
        title.text = "คะแนนเฉลี่ย";
        title.fontSize = 16;
        title.marginBottom = 0;
        title.align = "center";
        title.fontWeight = '400';

        // Add data
        if (data.avg == "0") {
            chart.data = [{
                "country": "Dummy",
                "disabled": true,
                "value": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];

            let label = chart.seriesContainer.createChild(am4core.Label);
            label.text = data.avg;  // "1995";
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 25;
            /* Create series */
            var series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "value";
            series.dataFields.category = "name";
            chart.innerRadius = am4core.percent(40);

            /* Set up slice appearance */
            var slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";
        } else {
            chart.data = data.lstData;
            // Add label
            // chart.innerRadius = 50;
            let label = chart.seriesContainer.createChild(am4core.Label);
            label.text = data.avg;  // "1995";
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 25;

            // Add and configure Series
            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "name";
            pieSeries.innerRadius = am4core.percent(50);
            pieSeries.ticks.template.disabled = true;
            pieSeries.labels.template.disabled = true;
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.tooltip.disabled = true;

            pieSeries.colors.list = [
                am4core.color("#edc935"),
            ];
            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            chart.hiddenState.properties.radius = am4core.percent(0);
        }

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: 5,
                    nOrder: 5,
                    sDesc: "Div 1 pie",
                    sName: "",
                    idDiv: 1,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <div id='SatisFactiondiv1' style={{padding:'8px'}}>
                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                    {
                                        data?.lstGraphBar.length > 0 ?
                                            data.lstGraphBar.map((element, index) => {
                                                return (
                                                    <Fragment key={`bar_Fragment_${index}`}>
                                                        {/* <Grid item xs={12}>
                                                            <Typography>{element.sQuestionair}</Typography>
                                                        </Grid> */}
                                                        <Grid item xs={12}>
                                                            <div id={`bar_${index + 1}`} style={{ width: "100%", height: "120px" }}></div>
                                                        </Grid>
                                                    </Fragment>
                                                )
                                            })
                                            : null
                                    }
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '15%' }}>
                                    <Grid item >
                                        <div id="pie_avg" style={{ width: "100%", height: "200px" }}></div>
                                    </Grid>
                                    {/* <Grid item >
                                        <Typography>คะแนนเฉลี่ย</Typography>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default AverageChart